import React, { useState, useEffect } from 'react'
import { CirclePackChart } from "@carbon/charts-react";
import TableToolbarDownload from '../../common/TableToolbarDownload';
import "@carbon/charts/styles.css";
import * as DashboardConstants from './DashboardConstants'

const DashboardCirclePackChart = (props) => {
    const defaultCirclePackChartOptions = {
        "experimental": "true",
        "canvasZoom": {
            "enabled": true
        },
        "legend": {
            "position": "top",
            "orientation": "horizontal",
            "alignment": "right"
        },
        "height": "400px"
    };

    const groupedBarGraphHeaders = [{key: 'group', header: DashboardConstants.group},{key: 'count', header: DashboardConstants.Count},
    {key: 'item', header: DashboardConstants.IncidentStatus}];

    return (
        <>
            {!props.loading && !props.circlePackChartData.length ?
                <div>{DashboardConstants.NoDataAvailable}</div>
                :
                <div className="dashboard-circle-pack-graph">
                    <div className="graph-title carbon-display-Regular-20">
                        <div>{props.title}</div>
                        <div className="download-button">
                            <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.downloadableData} headers={groupedBarGraphHeaders} title={props.title} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                        </div>
                    </div>
                    <CirclePackChart
                        data={props.circlePackChartData}
                        options={defaultCirclePackChartOptions}>
                    </CirclePackChart>
                </div>
            }
        </>
    );
};

export default DashboardCirclePackChart;

